/**
 * Static logo paths. Files live in public/assets/images/logos.
 */

export const LOGO_DIR = '/assets/images/logos';

export const LOGOS = {
  skoleom: `${LOGO_DIR}/logo-skoleom.webp`,
  skoleomBrand: `${LOGO_DIR}/logo-skoleom-brand.webp`,
  watchTouchBuy: `${LOGO_DIR}/watch-touch-buy.webp`,
  watchOnSkoleomWhite: '/logo/boutique/Watch%20on%20Skoleom%20White.webp',
  skoleomStudioWhiteTurq: `${LOGO_DIR}/skoleom-studio-white-turq.webp`,
  skoleomStudioLogoTurq: `${LOGO_DIR}/skoleom-studio-logo-turq.webp`,
  audiovisualStore: `${LOGO_DIR}/audiovisual-store.webp`,
  sesync: `${LOGO_DIR}/sesync.webp`,
  sesports: `${LOGO_DIR}/sesports.webp`,
  magazineLight: `${LOGO_DIR}/skoleom-magazine-light.webp`,
  magazineBlack: `${LOGO_DIR}/skoleom-magazine-black.webp`,
  skoleomPage: `${LOGO_DIR}/skoleom-page-logo.webp`,
  skoleomPageBlack: `${LOGO_DIR}/skoleom-page-logo.webp`,
  skoletoons: `${LOGO_DIR}/skoletoons.webp`,
  the25x: `${LOGO_DIR}/the25x.webp`,
  skoleomShop: `${LOGO_DIR}/skoleom-shop.webp`,
  skoleomPulse: '/logo/skoleom-pulse.webp',
  skoleomInvestBoutique: '/logo/SkoleomInvest.webp',
  services: `${LOGO_DIR}/skoleom-services-text.webp`,
  foodBeverage: `${LOGO_DIR}/skoleom-food-beverage-orange.webp`,
} as const;

export const PLATFORM_BRAND_LOGOS = {
  netflix: `${LOGO_DIR}/platforms/netflix.webp`,
  appleTv: `${LOGO_DIR}/platforms/apple-tv.webp`,
  disneyPlus: `${LOGO_DIR}/platforms/disney-plus.webp`,
} as const;

export const BOUTIQUE_BRAND_LOGOS: Readonly<Partial<Record<string, string>>> = {
  'av-sesports': LOGOS.sesports,
  'av-invest': `${LOGO_DIR}/skoleom-invest.webp`,
  'av-travel': `${LOGO_DIR}/skoleom-travel.webp`,
  'av-music': `${LOGO_DIR}/skoleom-music-dark.webp`,
  'av-realestate': `${LOGO_DIR}/skoleom-realestate.webp`,
  'av-services': LOGOS.services,
  'av-fnb': LOGOS.foodBeverage,
  'tous-page': LOGOS.skoleomPage,
  'tous-sesync': LOGOS.sesync,
  'tous-skoletoons': LOGOS.skoletoons,
  'tous-25x': LOGOS.the25x,
  'tous-shop': LOGOS.skoleomShop,
  'tous-magazine': LOGOS.magazineLight,
  'skoleom-business': `${LOGO_DIR}/skoleom-business.webp`,
  'skoleom-events': `${LOGO_DIR}/skoleom-events.webp`,
  'skoleom-invest': `${LOGO_DIR}/skoleom-invest.webp`,
  'skoleom-retailers': `${LOGO_DIR}/skoleom-retailers-dark.webp`,
  'skoleom-studios': `${LOGO_DIR}/skoleom-studio.webp`,
};
